import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Icon from 'components/global/Icon';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const StoreCard = styled.div`
	display: flex;
	gap: 1.7rem;
	border-radius: var(--medium-border-radius);
	border: 1px solid var(--border-color);
	padding: var(--padding-4);
	transition: all 0.1s;
	width: 100%;

	@media (${Breakpoints.mobile}) {
		align-items: flex-start;
		min-height: 15rem;
		text-align: left;
		padding: var(--padding-3) var(--padding-4);
	}
`;

export const StyledImage = styled(Image)`
	border-radius: var(--small-border-radius);

	@media (${Breakpoints.mobile}) {
		margin-bottom: 0;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	flex: 1;

	@media (${Breakpoints.mobile}) {
		align-items: flex-start;
	}
	body[dir='rtl'] & {
		text-align: right;
	}
`;

export const Actions = styled.div`
	margin-top: auto;
	width: 100%;
	@media (${Breakpoints.mobile}) {
		display: none;
	}
`;

export const MobileActions = styled.div`
	display: none;
	@media (${Breakpoints.mobile}) {
		display: flex;
	}
	align-self: center;
`;

export const StyledIcon = styled(Icon)`
	align-self: center;
	color: var(--blue);
	body[dir='rtl'] & {
		transform: rotate(180deg);
	}
`;

export const TitleCss = css`
	display: inline-block;
`;
